import React, { useState } from 'react';
import { Label, TextBold, TextMedium } from '../../../styles/GlobalStyledComponents';
import {
  CardCheckbox,
  CardInput,
  CardRow,
  CardSection,
  CheckboxContainer,
  InfoCardMiniSpan,
  InitialAmount,
  InitialAmountBox,
  CardLabel,
} from '../CardsStyledComponents';
import {
  AmountSection,
  CardPaymentColumn,
  CardPaymentSection,
  TextBoldAmount,
} from './PaymentQuotasStyledComponents';
import {
  StandardPaymentsData,
  TransactionReasonEnum,
  TransactionReasonTexts,
} from '../../../interfaces/Debt';
import { pricesHelper } from '../../../utils/paymentsHelper';
import GAnalyticsService from '../../../services/GAnalytics/ganalytics.service';
import { colors } from '../../../styles/Colors';
import dayjs from 'dayjs';


interface DebtProps {
  standardPayments: StandardPaymentsData;
  isSelected: boolean;
  onSelectInput: () => void;
  isOneQuotaDebt: boolean;
}

const PaymentQuotas: React.FC<DebtProps> = ({
  standardPayments,
  isSelected,
  onSelectInput,
  isOneQuotaDebt,
}) => {

  const [initTime] = useState<dayjs.Dayjs>(dayjs());

  return (
    <CardInput
      onClick={() => {
        if (!isSelected) {
          onSelectInput();
          GAnalyticsService.sendChangeDebtType(initTime, standardPayments.type);
        }
      }}
      selected={isSelected}
      borderColor={colors.red7}
      cardPadding="24px"
      id="standard-payment-select-radio-btn"
    >
      <CheckboxContainer
        id="standard-payment-select-checkbox-container"
      >
        <CardCheckbox
          id="standard-payment-checkbox"
          name="standard-payment"
          type="radio"
          checked={isSelected}
          readOnly
        />
        <Label htmlFor="standard-payment-checkbox" id="standard-payment-label"></Label>
      </CheckboxContainer>
      <CardPaymentColumn id="standard-payment-column">
        <CardSection id="standard-payment-section">
          <TextBold fontSize={16} lineHeight={22} id="standard-payment-text">
            {standardPayments.transaction_reason ===
              TransactionReasonEnum.DE1 && isOneQuotaDebt
              ? 'Deuda Pendiente'
              : TransactionReasonTexts[standardPayments.transaction_reason]}
          </TextBold>
        </CardSection>
        {standardPayments.amount_excused !== 0 && (
          <CardRow id="standard-payment-row">
            <TextMedium
              color={'gray6'}
              fontSize={14}
              lineHeight={20}
              id="standard-payment-regular-text"
            >
              {standardPayments.transaction_reason === TransactionReasonEnum.DE1
                ? 'Abona una cuota'
                : 'Abona la deuda total '}
              y ahorra los gastos
            </TextMedium>
          </CardRow>
        )}
        <CardPaymentSection id="standard-payment-card-section">
          <AmountSection id="standard-payment-amount-section">
            {standardPayments.amount_excused !== 0 && (
              <InitialAmountBox id="standard-payment-initial-amount-box">
                <InitialAmount
                  fontSize={14}
                  color={'red6'}
                  id="standard-payment-initial-amount-text"
                >
                  {pricesHelper(
                    standardPayments.amount + standardPayments.amount_excused
                  )}
                  €
                </InitialAmount>
              </InitialAmountBox>
            )}
            <TextBoldAmount fontSize={16} lineHeight={24}>
              {pricesHelper(standardPayments.amount)}€
            </TextBoldAmount>
          </AmountSection>
          {standardPayments.amount_excused !== 0 && (
            <InfoCardMiniSpan id="standard-payment-green-info-text">
              <CardLabel fontSize={14} lineHeight={16}>
                Ahorras{' '}
                {standardPayments &&
                  pricesHelper(standardPayments.amount_excused)}
                €
              </CardLabel>
            </InfoCardMiniSpan>
          )}
        </CardPaymentSection>
      </CardPaymentColumn>
    </CardInput>
  );
};

export default PaymentQuotas;
